import { z } from 'zod'
import type { Connection } from '#/domain/connection/Connection'

export const ConnectionDtoSchema = z
  .object({
    connection_id: z.string(),
    connection: z.object({
      name: z.string(),
      strategy: z.string(),
    }),
  })
  .transform((raw): Connection => ({
    id: raw.connection_id,
    name: raw.connection.name,
    strategy: raw.connection.strategy,
  }))

export type ConnectionResponseDto = z.input<typeof ConnectionDtoSchema>

export function toDomain(raw: ConnectionResponseDto): Connection {
  return ConnectionDtoSchema.parse(raw)
}

export function toDomainList(raw: ConnectionResponseDto[]): Connection[] {
  return raw.map(toDomain)
}
